<template>
  <!-- chrome displays warnings if type=password is not in a form-->
  <form ref="editForm" class="edit-form row wrap no-gutters">

    <v-col cols="12" sm="6">
      <v-text-field v-model.trim="userForm.oldpassword"
                    v-validate="'required'"
                    :error-messages="errors.collect('oldpassword')"
                    type="password"
                    data-vv-as="Altes Passwort"
                    class="required"
                    name="oldpassword"
                    label="Altes Passwort"
                    autocomplete="current-password" />
    </v-col>
    <v-col cols="12" sm="6"/>

    <v-col cols="12" sm="6">
      <v-text-field ref="passwort"
                    v-model.trim="userForm.newpassword"
                    v-validate="{required: true, regex: /(?=.*\d)(?=.*[a-zA-Z])(?=^.{8,}$)/}"
                    :error-messages="errors.collect('passwort')"
                    type="password"
                    data-vv-as="Neues Passwort"
                    class="required"
                    name="passwort"
                    label="Neues Passwort"
                    autocomplete="new-password" />
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model.trim="confirmPassword"
                    v-validate="'required|confirmed:passwort'"
                    :error-messages="errors.collect('passwort2')"
                    type="password"
                    data-vv-as="Bestätigung des Passworts"
                    class="required"
                    name="passwort2"
                    label="Neues Passwort bestätigen"
                    autocomplete="new-password" />
    </v-col>

  </form>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";

export default {
  name: "EditPasswort",
  mixins: [ ValidationMixin ],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmPassword: ''
    };
  },
};
</script>
